import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';

import styled from 'styled-components';
import {
    Flex,
    mobileMediaQuery,
    notMobileMediaQuery,
    useBreakpoint,
    webMediaQuery,
} from './../../styles';

import BigButton from './../BigButton';

import Home from './../../assets/ic_cn_home.png';
import HomeSelected from './../../assets/ic_cn_home_selected.png';
import Shows from './../../assets/ic_cn_shows.png';
import ShowsSelected from './../../assets/ic_cn_shows_selected.png';
import Now from './../../assets/ic_cn_onnow.png';
import NowSelected from './../../assets/ic_cn_onnow_selected.png';
import Games from './../../assets/ic_cn_games.png';
import GamesSelected from './../../assets/ic_cn_games_selected.png';
import Comics from './../../assets/ic_cn_comics.png';
import ComicsSelected from './../../assets/ic_cn_comics_selected.png';
import Movies from './../../assets/popcorn_icon.svg';
import {currentEnv, useBrand, useIsCartoonito} from '../../helpers';
import {analyticsTrackAction} from '../../helpers/Analytics';

const Container = styled(Flex)`
    position: fixed;
    background-color: black;
    width: 100%;
    height: 64px;
    z-index: 100;
    bottom: 0;
    box-sizing: border-box;

    ${webMediaQuery} {
        display: none;
    }
`;

const ButtonsRow = styled.nav`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;

    button {
        flex: 1;
        width: auto;
        min-width: initial;
        justify-content: flex-end;

        img {
            width: 24px;
            height: 23px;
            margin: 0 0 4px 0 !important;
        }

        span {
            font-size: 14px;

            ${mobileMediaQuery} {
                font-size: 10px;
                line-height: 24px;
            }
        }

        ${mobileMediaQuery} {
            padding-bottom: 0px;
        }
    }
`;

const CartoonitoButton = styled.button`
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgb(8, 0, 8);
    border-radius: 0px;
    border: none;
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    color: rgb(255, 255, 255);
    font-size: 18px;
    font-family: 'LubalinGraphStd';
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;

    ${notMobileMediaQuery} {
        display: none;
    }
`;

const BottomNav = props => {
    const history = useHistory();
    const breakpoint = useBreakpoint();
    const brand = useBrand();

    const isMobile = ['xs', 'mobile'].includes(breakpoint);
    const isTablet = ['sm', 'md'].includes(breakpoint);

    const {t} = useTranslation();
    const pathname = props.currentPathname || history.location.pathname;

    const user = useSelector(state => state.user);
    const config = useSelector(state => state.config);
    const movie = useSelector(state => state.movie);

    const [movies, setMovies] = useState(undefined);

    useEffect(() => {
        if (movie.movies !== undefined) {
            setMovies(movie.movies);
        }

        // eslint-disable-next-line
    }, [movie.movies]);

    const noBottomNav = () => {
        let show = false;
        const parts = history.location.pathname.split('/');
        parts.shift(); //don't care about first item, as its a blank string

        if (
            history.location.pathname.indexOf('/play') >= 0 ||
            history.location.pathname.indexOf('/shows/') >= 0 ||
            history.location.pathname.indexOf('/now/') >= 0 ||
            (parts[0] === 'comics' && parts.length === 3)
        ) {
            show = true;
        }

        return show;
    };

    const handleGoToCNAPP = () => {
        if (currentEnv !== 'prd') {
            history.push('/home');
        } else {
            window.location.href = 'https://cnapp.cartoonnetwork.com.br';
        }
    };

    if (brand !== 'cnapp') {
        return null;
    }

    if (
        (brand !== 'cnapp' ||
            ['/cartoonito', '/programacao', '/programacion'].includes(
                history.location.pathname,
            )) &&
        !noBottomNav()
    ) {
        return (
            <CartoonitoButton onClick={handleGoToCNAPP}>
                {t('cartoonito.header.cnappCTA')}
            </CartoonitoButton>
        );
    }

    const trackHomeClick = () => {
        trackMenuClick('home');
    };
    const trackShowsClick = () => {
        trackMenuClick('shows');
    };
    const trackGamesClick = () => {
        trackMenuClick('games');
    };
    const trackComicsClick = () => {
        trackMenuClick('comics');
    };
    const trackFavoritesClick = () => {
        trackMenuClick('favorites');
    };

    const trackMenuClick = link => {
        //get current section
        let section = window.location.pathname.split('/')[1];
        analyticsTrackAction('main nav click', {
            section: section,
            subsection: section,
            linkname: `cnplus.com/${link}`,
            contentclickevent: '1',
            mainnavclickevent: '1',
        });
    };

    return ((config.btw && config.btw.enabled) || (user && user.jwtToken)) &&
        !noBottomNav() ? (
        <Container>
            {
                <ButtonsRow>
                    <BigButton
                        active={pathname === '/home' || pathname === '/'}
                        icon={
                            pathname === '/home' || pathname === '/'
                                ? HomeSelected
                                : Home
                        }
                        onClick={() => {
                            trackHomeClick();
                            history.push('/home');
                        }}
                        value={t('home.title')}
                        iconWidth="36px"
                        iconHeight="35px"
                        title={t('home.title')}
                        gradient
                    />

                    <BigButton
                        active={pathname.indexOf('/shows') >= 0}
                        icon={
                            pathname.indexOf('/shows') >= 0
                                ? ShowsSelected
                                : Shows
                        }
                        onClick={() => {
                            trackShowsClick();
                            history.push('/shows');
                        }}
                        value={t('shows.title')}
                        iconWidth="36x"
                        iconHeight="35px"
                        title={t('shows.title')}
                        gradient
                    />

                    {false && movies && movies.length > 0 && (
                        <BigButton
                            active={pathname.indexOf('/movies') >= 0}
                            icon={Movies}
                            onClick={() => history.push('/movies')}
                            value={t('movies.title')}
                            iconWidth="36px"
                            iconHeight="30px"
                            title={t('movies.title')}
                            gradient
                        />
                    )}

                    <BigButton
                        active={pathname.indexOf('/games') >= 0}
                        icon={
                            pathname.indexOf('/games') >= 0
                                ? GamesSelected
                                : Games
                        }
                        onClick={() => {
                            trackGamesClick();
                            history.push('/games');
                        }}
                        value={t('games.title')}
                        iconWidth="28px"
                        iconHeight="28px"
                        title={t('games.title')}
                        gradient
                    />
                    <BigButton
                        active={pathname.indexOf('/now') >= 0}
                        icon={pathname.indexOf('/now') >= 0 ? NowSelected : Now}
                        onClick={() => history.push('/now')}
                        value={t('onnow.title')}
                        iconWidth="36px"
                        iconHeight="30px"
                        title={t('onnow.title')}
                        gradient
                    />
                    <BigButton
                        active={pathname.indexOf('/comics') >= 0}
                        icon={
                            pathname.indexOf('/comics') >= 0
                                ? ComicsSelected
                                : Comics
                        }
                        onClick={() => {
                            trackComicsClick();
                            history.push('/comics');
                        }}
                        value={t('comics.title')}
                        iconWidth="28px"
                        iconHeight="28px"
                        title={t('comics.title')}
                        gradient
                    />
                </ButtonsRow>
            }
        </Container>
    ) : null;
};

export default BottomNav;
